import ButtonBase from 'components/partials/button'
import InputBase from 'components/partials/inputBase'
import React, { useEffect, useState } from 'react'

interface PropsAction {
  listItem: string[]
  title: string
  placeholder: string
  handleOnChangeItems?: (items: string[]) => void
}

const EditableListInline: React.FunctionComponent<PropsAction> = ({
  listItem,
  title,
  placeholder,
  handleOnChangeItems = () => null
}) => {
  const [phoneItems, setPhoneItems] = useState(listItem)
  const [newItem, setNewPhone] = useState('')

  const addItem = () => {
    if (newItem.trim() !== '') {
      setPhoneItems([...phoneItems, newItem.trim()])
      setNewPhone('')
    }
  }
  useEffect(() => {
    handleOnChangeItems(phoneItems)
   }, [phoneItems])

  const removeItem = (index: number) => {
    setPhoneItems(phoneItems.filter((_, i) => i !== index))
  }

  return (
    <div className="mx-auto mt-1 bg-white">
      {/* <h1 className="text-2xl font-bold mb-4 text-center">{title}</h1> */}
      <div className="flex space-x-2 mb-4 max-w-md mx-auto">
        <InputBase
          type="text"
          className="flex-1 border border-gray-300 rounded "
          placeholder={placeholder}
          value={newItem ?? ''}
          handleChange={(e) => setNewPhone(e)}
        />
        <ButtonBase
          onClick={addItem}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Add
        </ButtonBase>
      </div>
      <div className="overflow-x-auto">
        <div className="min-w-full">
          <div className="flex flex-wrap gap-2 max-h-20">
            {phoneItems && phoneItems.length > 0 && phoneItems.map((item, index) => (
              <div
                key={index}
                className="flex items-center bg-gray-100 rounded-full px-4 py-2"
              >
                <span className="mr-2">{item}</span>
                <button
                  onClick={() => removeItem(index)}
                  className="text-red-500 hover:text-red-700"
                >
                  X
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditableListInline